import React from "react";

interface FooterProps {
    home? : () => void;
}

export default function Footer(props : FooterProps) {
    return <footer>
        <img src="images/shared/footer-logo.png" className="logo" alt="" />
        <p>Mobilne Centrum Edukacji Turystyczna Szkoła</p>
        {props.home !== undefined &&
            <img src="images/shared/btn-home.png" className="home" onClick={props.home} alt="" />
        }
    </footer>
}